<mh-core-lib-button
  [isDefault]="true"
  [text]="'prestay.configurations.general.index.check_setup' | translate"
  [customClass]="'tw-text-sm'"
  (clicked)="onCheckSetup()">
</mh-core-lib-button>
